export const revisionExpressTranslations = {
  fr: {
    title: "Révision Express",
    urgentCards: "cartes urgentes",
    minutes: "minutes",
    loading: "Chargement...",
    noUrgentCards: "Aucune flashcard urgente à réviser !",
    loadError: "Erreur lors du chargement des flashcards",
    readyInfo: "⚡ Révisez vos cartes les plus urgentes en mode express",
    timerStartInfo: "Le timer démarre quand vous cliquez sur Commencer",
    start: "Commencer",
    back: "Retour",
    sessionComplete: "Session terminée !",
    greatWork: "Excellent travail !",
    correct: "Correctes",
    accuracy: "Précision",
    earnedInSession: "Gagné dans cette session",
    shareScore: "Partager mon score",
    shareText: "⚡ Révision Express : {{correct}}/{{total}} ({{accuracy}}%) sur Sclépios IA !",
    backToFlashcards: "Retour aux flashcards",
    newExpressSession: "Nouvelle session express",
    question: "Question",
    answer: "Réponse",
    clickToSeeAnswer: "Cliquez pour voir la réponse",
    howDidYouAnswer: "Comment avez-vous répondu ?",
    incorrect: "Incorrect",
    correctBtn: "Correct",
    correctCount: "correctes",
    expressMode: "⚡ Mode Express : Révisez 10 cartes urgentes en 5 minutes",
  },
  en: {
    title: "Express Review",
    urgentCards: "urgent cards",
    minutes: "minutes",
    loading: "Loading...",
    noUrgentCards: "No urgent flashcards to review!",
    loadError: "Error loading flashcards",
    readyInfo: "⚡ Review your most urgent cards in express mode",
    timerStartInfo: "The timer starts when you click Start",
    start: "Start",
    back: "Back",
    sessionComplete: "Session complete!",
    greatWork: "Great work!",
    correct: "Correct",
    accuracy: "Accuracy",
    earnedInSession: "Earned in this session",
    shareScore: "Share my score",
    shareText: "⚡ Express Review: {{correct}}/{{total}} ({{accuracy}}%) on Sclépios AI!",
    backToFlashcards: "Back to flashcards",
    newExpressSession: "New express session",
    question: "Question",
    answer: "Answer",
    clickToSeeAnswer: "Click to see the answer",
    howDidYouAnswer: "How did you answer?",
    incorrect: "Incorrect",
    correctBtn: "Correct",
    correctCount: "correct",
    expressMode: "⚡ Express Mode: Review 10 urgent cards in 5 minutes",
  },
  es: {
    title: "Repaso Express",
    urgentCards: "tarjetas urgentes",
    minutes: "minutos",
    loading: "Cargando...",
    noUrgentCards: "¡No hay tarjetas urgentes para repasar!",
    loadError: "Error al cargar las tarjetas",
    readyInfo: "⚡ Repasa tus tarjetas más urgentes en modo express",
    timerStartInfo: "El temporizador comienza al hacer clic en Comenzar",
    start: "Comenzar",
    back: "Volver",
    sessionComplete: "¡Sesión completada!",
    greatWork: "¡Excelente trabajo!",
    correct: "Correctas",
    accuracy: "Precisión",
    earnedInSession: "Ganado en esta sesión",
    shareScore: "Compartir mi puntuación",
    shareText: "⚡ Repaso Express: {{correct}}/{{total}} ({{accuracy}}%) en Sclépios IA!",
    backToFlashcards: "Volver a las tarjetas",
    newExpressSession: "Nueva sesión express",
    question: "Pregunta",
    answer: "Respuesta",
    clickToSeeAnswer: "Haz clic para ver la respuesta",
    howDidYouAnswer: "¿Cómo respondiste?",
    incorrect: "Incorrecto",
    correctBtn: "Correcto",
    correctCount: "correctas",
    expressMode: "⚡ Modo Express: Repasa 10 tarjetas urgentes en 5 minutos",
  },
};
